import React from "react";
import { Navigate } from "react-router-dom";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import { getUserRole } from "helpers/fakebackend_helper";
import Organizers from "pages/Organizers/Dashboard";

//Organizers Pages
import SponsorDashboard from "pages/Organizers/Dashboard";
import OrganizersBookings from "pages/Organizers/Bookings";
import OrganizersEvents from "pages/Organizers/Events";
import OrganizerList from "pages/Admin/Organizers/OrganizerList";
import EventList from "pages/Admin/Events/EventList";
import CreateEvent from "pages/Admin/Events/CreateEvent";
import CreateQuickEvent from "pages/Admin/Events/CreateQuickEvent";
import EventTickets from "pages/Admin/Events/EventTickets";
import EventTicketByEvent from "pages/Admin/Events/EventTicketByEvent";
import ForumList from "pages/Admin/Forum/ForumList";
import Reports from "pages/Admin/Report/Reports";
import AttendeeReport from "pages/Admin/Report/AttendeeReport";
import EventSummary from "pages/Admin/Report/EventSummary";
import BookingAllStatus from "pages/Admin/Report/BookingAllStatus";
import OrganizerReports from "pages/Organizers/Report/OrganizerReports";
import OrganizerAttendeeReport from "pages/Organizers/Report/OrganizerAttendeeReport";
import OrganizerEventSummary from "pages/Organizers/Report/OrganizerEventSummary";
import EventVenue from "pages/Admin/Events/EventVenue";
import OrganizerEventTickets from "pages/Organizers/Events/OrganizerEventTickets";
import OrganizerEventVenue from "pages/Organizers/Events/OrganizerEventVenue";
import EditEvent from "pages/Admin/Events/EditEvent";
import OrganizerCoupon from "pages/Organizers/Events/OrganizerCoupon";
import AdminCoupon from "pages/Admin/Coupons";
import SpotBooking from "pages/Admin/Events/SpotBooking";
import TicketSummery from "pages/Organizers/Report/TicketSummery";
import Contact from "pages/Admin/Contacts/Contact";
import SponsorList from "pages/Admin/Sponsors/SponsorList";
import ManagePassword from "pages/Admin/PasswordManager/ManagePassword";
import EventoxRevenue from "pages/Admin/Report/EventoxRevenue";
import BookingSlot from "pages/Admin/Tickets/BookingSlot";
import TicketGroup from "pages/Admin/Tickets/TicketGroup";
import BookingStatus from "../pages/Admin/Reportv3/BookingStatus";
import FreeBooking from "pages/Admin/Tickets/FreeBooking";
import EventDetails from "pages/Admin/Events/EventDetails";
import EventoxRevenueInDateRange from "pages/Admin/Report/EventoxRevenueInDateRange";
import RunReport from "pages/Admin/Report/RunReport";
import BookingDetails from "pages/Admin/Report/BookingDetails";
import NewUser from "pages/Admin/NewUser/NewUser";
import OrganizerEntitlements from "pages/Admin/Entitlements/OrganizerEntitlements";
import ManageEntitlements from "pages/Admin/Entitlements/ManageEntitlements";
import VenueList from "pages/Admin/Venues/VenueList";
import DiscoverManagement from "pages/Admin/Discover/DiscoverManagement";
import CountryAdmin from "pages/Admin/CountryAdmin/CountryAdmin";
import CreateListEvent from "pages/Admin/PublicEventList/CreateListEvent";
import ListEvents from "pages/Admin/PublicEventList/ListEvents";
import ArtistList from "pages/Admin/Artists/ArtistList";
import InquireList from "pages/Admin/Inquires/InquireList";
import PublicVenueList from "pages/Admin/PublicVenues/PublicVenueList";
import Refund from "pages/Admin/Refund/Refund";
const role = getUserRole();
const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  // { path: "/s-dashboard", component: <SponsorDashboard /> },
  { path: "/organizers", component: <OrganizerList /> },
  { path: "/sponsors", component: <SponsorList /> },
  { path: "/admin/events", component: <EventList /> },
  { path: "/event/new", component: <CreateEvent /> },
  { path: "/event/newquick", component: <CreateQuickEvent /> },
  { path: "/admin/events/edit/:id", component: <EditEvent /> },
  { path: "/event-ticket", component: <EventTickets /> },
  { path: "/ticket-by-event/:slugId", component: <EventTicketByEvent /> },
  { path: "/forum", component: <ForumList /> },
  {path:"/reports",component:<Reports/>},
  {path:"/attendee-report",component:<AttendeeReport/>},
  {path:"/event-summery-report",component:<EventSummary/>},
  {path:"/eventox-revenue-report",component:<EventoxRevenue/>},
  {path:"/Reportv3/booking-status-report",component:<BookingStatus/>},
  {path:"/Reportv3/revenue-date-report",component:<EventoxRevenueInDateRange/>},
  {path:"/event-venue",component:<EventVenue/>},
  {path:"/coupons",component:<AdminCoupon/>},
  {path:"/contact-list",component:<Contact/>},
  {path:"/sponsor-list",component:<SponsorList/>},
  {path:"/ManagePassword",component:<ManagePassword/>},
  {path:"/ticket-group",component:<TicketGroup/>},
  {path:"/booking-slot",component:<BookingSlot/>},
  {path:"/free-ticket",component:<FreeBooking/>},
  {path:"/spot-booking",component:<SpotBooking/>},
  {path: "/event-detail/:id", component: <EventDetails /> },
  {path:"/run-report",component:<RunReport/>},
  {path:"/admin/report/booking-details/:bookingNo",component:<BookingDetails/>},
  {path:"/new-user",component:<NewUser/>},
  {path:"/Organizer-Entitlements",component:<OrganizerEntitlements/>},
  {path:"/manage-entitlements",component:<ManageEntitlements/>},
  { path: "/venues", component: <VenueList /> },
  {path:"/discover-management",component:<DiscoverManagement/>},
  {path:"/country-admin",component:<CountryAdmin/>},
  { path: "/artist-management", component: <ArtistList /> },
  { path: "/inquires", component: <InquireList /> },
  { path: "/public-venue-list", component: <PublicVenueList /> },

  {path:"/create-list-event",component:<CreateListEvent/>},
  {path:"/list-event",component:<ListEvents/>},
  
  { path: "/refund", component: <Refund /> },


  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: (role === 1 || role === 5) ? <Navigate to="/dashboard" /> : <Navigate to="/s-dashboard" />,
  },
];

const authSponsorProtectedRoutes = [
  { path: "/s-dashboard", component: <OrganizerAttendeeReport /> },
  { path: "/bookings", component: <OrganizersBookings /> },
  { path: "/organizer-events", component: <OrganizersEvents /> },
  { path: "/organizer-report", component: <OrganizerReports /> },
  { path: "/organizer-attendee-report", component: <OrganizerAttendeeReport /> },
  { path: "/organizer-event-summery-report", component: <OrganizerEventSummary /> },
  { path: "/organizer-events", component: <OrganizersEvents /> },
  { path: "/organizer-event-ticket", component: <OrganizerEventTickets /> },
  { path: "/organizer-event-venue", component: <OrganizerEventVenue /> },
  {path:"/organizer-event-coupon",component:<OrganizerCoupon/>},
  {path:"/organizer-event-spot-booking",component:<SpotBooking/>},
  {path:"/organizer-ticket-summery-report",component:<TicketSummery/>},
  
  


  { path: "/profile", component: <UserProfile /> },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
 
];
const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes,authSponsorProtectedRoutes };